import React, { FC } from 'react';
import MuiSnackbar, { SnackbarProps as MuiSnackbarProps } from '@material-ui/core/Snackbar';

import { makeStyles } from 'design-system/styles';

export { default as SnackbarContent } from '@material-ui/core/SnackbarContent';

type AllowedMuiSnackbarProps =
  | 'action'
  | 'anchorOrigin'
  | 'autoHideDuration'
  | 'message'
  | 'onClose'
  | 'onExited'
  | 'open'
  | 'children'
  | 'className'
  | 'ContentProps'
  | 'classes';

type SnackbarProps = Pick<MuiSnackbarProps, AllowedMuiSnackbarProps>;

const useStyles = makeStyles(theme => ({
  anchorOriginTopCenter: {
    // TODO should make this opt-in with either a marginTop prop, or being able to specify portal root
    top: theme.spacing(8),
  },
}));

const Snackbar: FC<SnackbarProps> = props => {
  const classes = useStyles(props);

  return <MuiSnackbar classes={classes} {...props} />;
};

export default Snackbar;
